module.exports = __webpack_public_path__ + "assets/img/791c122e68df1297c0eaf78d8455baa3.svg";